import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Button, Modal } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { useToast } from 'context/providers/ToastProvider';


const ModalCalcularRecibidas = (

    {
        setShowModal,
        showModal,
        dateQuarter,
        selectedRfc,
        searchTerm,
        serie,
        formaPago,
        tipoComprobante
    }

) => {

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();

    const [facturasRecibidas, setFacturasRecibidas] = useState([]);
    const [egresoPPD, setEgresoPPD] = useState({});
    const [egresoPUE, setEgresoPUE] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (showModal) {
            ObtenerDatosModal();
        }
    }, [showModal]);

    /**
     * Obtiene los Datos de los Gastos
     */
    const ObtenerDatosModal = async () => {

        var date_ = sessionStorage.getItem("selectMes") == null ? dateQuarter : sessionStorage.getItem("selectMes");


        var month = new Date(date_).getMonth();
        month = month + 1;
        var year = new Date(date_).getFullYear();

        const data = {
            year: year,
            month: month,
            rfc: selectedRfc,
            searchTerm: searchTerm,
            serie: serie,
            formaPago: formaPago,
            tipoComprobante: tipoComprobante
        }
        console.log("==== MES ENVIADO ====", data);
        setIsLoading(true)


        const response = await fetch("/api/FacturasRecibidas/ObtenerCalculoModalRecibidas",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .catch((error) => {
                setIsLoading(false);
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {

            console.log("==== OBTENER DATOS FACTURAS ====");

            const data = await response.json();


            console.log("SIN PARSEAR", data)

            if (data.iResponseType == 1) {


                var ObjDetalles = JSON.parse(data.detalles);

                console.log("ImpuestosDATA", ObjDetalles);

                setFacturasRecibidas(ObjDetalles.table2);
                setEgresoPPD(ObjDetalles.table3?.[0] ?? {});
                setEgresoPUE(ObjDetalles.table4?.[0] ?? {});
                setIsLoading(false);

            } else {
                showErrorToast(data.vMessage);
            }
            setIsLoading(false);


        }
        else {
            setIsLoading(false);
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    return (
        <>
            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title>Resultados de Cálculo</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="g-3">
                        <Col md={12}>
                            <div className="border rounded shadow-sm mt-4">
                                <h6 className="fw-bold p-2 bg-light border-bottom mb-0">COMPROBANTES DE EGRESO</h6>
                                <div className="p-2">
                                    {/* Primera fila con PUE y PPD */}
                                    <Row className="mb-3">
                                        {/* Columna PUE */}
                                        <Col md={6} className="pe-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">Ingreso PUE - Pago en una exhibición</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    {isLoading ? (
                                                        <Skeleton width={80} height={15} />
                                                    ) : (
                                                        <span className="fw-semibold">
                                                            ${(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dTotalSubTotal || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    {isLoading ? (
                                                        <Skeleton width={80} height={15} />
                                                    ) : (
                                                        <span className="fw-semibold">
                                                            ${(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dDescuento || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                        </span>
                                                    )}
                                                </div>

                                                {/* Impuestos Trasladados desglosados */}
                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA:</span>
                                                        {isLoading ? (
                                                            <Skeleton width={80} height={15} />
                                                        ) : (
                                                            <span className="fw-semibold">
                                                                ${(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dIva || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                            </span>
                                                        )}
                                                </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IEPS:</span>
                                                        {isLoading ? (
                                                            <Skeleton width={80} height={15} />
                                                        ) : (
                                                            <span className="fw-semibold">
                                                                ${(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dIEPS || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Impuestos Retenidos desglosados */}
                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA RET:</span>
                                                        {isLoading ? (
                                                            <Skeleton width={80} height={15} />
                                                        ) : (
                                                            <span className="fw-semibold">
                                                                ${(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dIvaRetenido || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">ISR RET:</span>
                                                        {isLoading ? (
                                                            <Skeleton width={80} height={15} />
                                                        ) : (
                                                            <span className="fw-semibold">
                                                                ${(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dIsrRetenido || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-between fw-bold small border-top pt-1">
                                                    <span className="text-secondary">Total Impuestos Trasladados:</span>
                                                    {isLoading ? (
                                                        <Skeleton width={80} height={15} />
                                                    ) : (
                                                        <span className="fw-semibold">
                                                            ${(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dTotalImpuestosTrasladados || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Total Impuestos Retenidos:</span>
                                                    {isLoading ? (
                                                        <Skeleton width={80} height={15} />
                                                    ) : (
                                                        <span className="fw-semibold">
                                                            ${(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dTotalImpuestosRetenidos || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                        </span>
                                                    )}
                                                </div>

                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    {isLoading ? (
                                                        <Skeleton width={80} height={15} />
                                                    ) : (
                                                        <span className="text-dark">
                                                            ${(facturasRecibidas.find(f => f.vMetodoPago === "PUE")?.dTotal || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Columna PPD */}
                                        <Col md={6} className="ps-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">Ingreso PPD - Pago parcialidades</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    {isLoading ? (
                                                        <Skeleton width={80} height={15} />
                                                    ) : (
                                                        <span className="fw-semibold">
                                                            ${(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dTotalSubTotal || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    {isLoading ? (
                                                        <Skeleton width={80} height={15} />
                                                    ) : (
                                                        <span className="fw-semibold">
                                                            ${(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dDescuento || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                        </span>
                                                    )}
                                                </div>

                                                {/* Impuestos Trasladados desglosados */}
                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA:</span>
                                                        {isLoading ? (
                                                            <Skeleton width={80} height={15} />
                                                        ) : (
                                                            <span className="fw-semibold">
                                                                ${(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dIva || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IEPS:</span>
                                                        {isLoading ? (
                                                            <Skeleton width={80} height={15} />
                                                        ) : (
                                                            <span className="fw-semibold">
                                                                ${(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dIEPS || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Impuestos Retenidos desglosados */}
                                                <div className="mt-2">
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">IVA RET:</span>
                                                        {isLoading ? (
                                                            <Skeleton width={80} height={15} />
                                                        ) : (
                                                            <span className="fw-semibold">
                                                                ${(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dIvaRetenido || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="d-flex justify-content-between small">
                                                        <span className="text-secondary">ISR RET:</span>
                                                        {isLoading ? (
                                                            <Skeleton width={80} height={15} />
                                                        ) : (
                                                            <span className="fw-semibold">
                                                                ${(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dIsrRetenido || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between small border-top pt-1 fw-bold">
                                                    <span className="text-secondary">Total Impuestos Trasladados:</span>
                                                    {isLoading ? (
                                                        <Skeleton width={80} height={15} />
                                                    ) : (
                                                        <span className="fw-semibold">
                                                            ${(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dTotalImpuestosTrasladados || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between small border-top pt-1 fw-bold">
                                                    <span className="text-secondary">Total Impuestos Retenidos:</span>
                                                    {isLoading ? (
                                                        <Skeleton width={80} height={15} />
                                                    ) : (
                                                        <span className="fw-semibold">
                                                            ${(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dTotalImpuestosRetenidos || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    {isLoading ? (
                                                        <Skeleton width={80} height={15} />
                                                    ) : (
                                                        <span className="text-dark">
                                                            ${(facturasRecibidas.find(f => f.vMetodoPago === "PPD")?.dTotal || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    {/* Segunda fila con EGRESO PPD y PUE */}
                                    <Row>
                                        {/* Columna EGRESO PPD */}
                                        <Col md={6} className="pe-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">EGRESO - PPD (Pago parcialidades)</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    {isLoading ? <Skeleton width={80} height={15} /> : (
                                                        <span className="fw-semibold">${(egresoPPD?.dTotalSubTotal || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}</span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    {isLoading ? <Skeleton width={80} height={15} /> : (
                                                        <span className="fw-semibold">${(egresoPPD?.dDescuento || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}</span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between small border-top pt-1">
                                                    <span className="text-secondary">IVA:</span>
                                                    {isLoading ? <Skeleton width={80} height={15} /> : (
                                                        <span className="fw-semibold">${(egresoPPD?.dIva || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}</span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between small">
                                                    <span className="text-secondary">IEPS:</span>
                                                    {isLoading ? <Skeleton width={80} height={15} /> : (
                                                        <span className="fw-semibold">${(egresoPPD?.dIEPS || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}</span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Total impuestos trasladados:</span>
                                                    {isLoading ? <Skeleton width={80} height={15} /> : (
                                                        <span className="fw-semibold">${(egresoPPD?.dTotalImpuestosTrasladados || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}</span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    {isLoading ? <Skeleton width={80} height={15} /> : (
                                                        <span className="text-dark">${(egresoPPD?.dTotal || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>

                                        {/* Columna EGRESO PUE */}
                                        <Col md={6} className="ps-1">
                                            <div className="border p-2 bg-white rounded">
                                                <small className="d-block fw-bold text-uppercase text-primary mb-2">EGRESO - PUE (Pago en una exhibición)</small>

                                                <div className="d-flex justify-content-between small fw-bold">
                                                    <span className="text-secondary">Subtotal:</span>
                                                    {isLoading ? <Skeleton width={80} height={15} /> : (
                                                        <span className="fw-semibold">${(egresoPUE?.dTotalSubTotal || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}</span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Descuento:</span>
                                                    {isLoading ? <Skeleton width={80} height={15} /> : (
                                                        <span className="fw-semibold">${(egresoPUE?.dDescuento || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}</span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between small border-top pt-1">
                                                    <span className="text-secondary">IVA:</span>
                                                    {isLoading ? <Skeleton width={80} height={15} /> : (
                                                        <span className="fw-semibold">${(egresoPUE?.dIva || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}</span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between small">
                                                    <span className="text-secondary">IEPS:</span>
                                                    {isLoading ? <Skeleton width={80} height={15} /> : (
                                                        <span className="fw-semibold">${(egresoPUE?.dIEPS || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}</span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between small fw-bold border-top pt-1">
                                                    <span className="text-secondary">Total impuestos trasladados:</span>
                                                    {isLoading ? <Skeleton width={80} height={15} /> : (
                                                        <span className="fw-semibold">${(egresoPUE?.dTotalImpuestosTrasladados || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}</span>
                                                    )}
                                                </div>
                                                <div className="d-flex justify-content-between border-top pt-1 mt-1 fw-bold">
                                                    <span>Total:</span>
                                                    {isLoading ? <Skeleton width={80} height={15} /> : (
                                                        <span className="text-dark">${(egresoPUE?.dTotal || 0).toLocaleString('en-MX', { minimumFractionDigits: 2 })}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    );

};


ModalCalcularRecibidas.propTypes = {
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func,
    selectedRfc: PropTypes.string,
    dateQuarter: PropTypes.instanceOf(Date),
    searchTerm: PropTypes.string,
    serie: PropTypes.string,
    formaPago: PropTypes.string,
    tipoComprobante: PropTypes.string
};
export default ModalCalcularRecibidas;
